import Layout from "../../components/layout";
import poster from "../../assets/images/AboutDevelopers.png";
const AboutTeam = () => {
  return (
    <Layout>
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            درباره توسعه دهنده
          </div>
          <div className='p-4'>
            <img
              src={poster}
              alt='About Tiara'
            />
            <br />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutTeam;
